import axios from "axios";
import { baseApi } from "../utils/routeNames";

const Http = axios.create({});
Http.defaults.baseURL = baseApi;
Http.defaults.headers.common.Accept = "application/json";

export default Http;
